module.exports = __webpack_public_path__ + "static/img/case-gl-page-bg-04.6e8c57d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/gl/case-gl-page-bg-04.png
// module id = AytY
// module chunks = 1